import React, { useEffect, useState } from 'react';

import { IssueStatus } from '@qality/common-model';
import { useTestCaseRepositoryFiltersContext } from '@qality/common-pages/src/TestCaseRepositoryPage';
import { IssueStatusService } from '@qality/common-service';

export type Props = {
  children: React.ReactNode;
};

export type IssueStatusesContextProps = {
  issueStatuses: Array<IssueStatus>;
  isIssueStatusesLoaded: boolean;
};

export const IssueStatusesContext =
  React.createContext<IssueStatusesContextProps>({
    issueStatuses: null,
    isIssueStatusesLoaded: false,
  });

export default function IssueStatusesProvider({
  children,
}: Props): JSX.Element {
  const { projectFilter } = useTestCaseRepositoryFiltersContext();

  const [issueStatuses, setIssueStatuses] = useState<Array<IssueStatus>>([]);
  const [issueAllStatuses, setIssueAllStatuses] =
    useState<Array<IssueStatus>>(null);
  const [isIssueStatusesLoaded, setIsIssueStatusesLoaded] = useState(true);

  useEffect(() => {
    const initProjectsIssueStatuses = async () => {
      setIssueStatuses(
        await IssueStatusService.getAllStatusesForProjects(
          projectFilter.map((project) => project.id)
        )
      );
      setIsIssueStatusesLoaded(true);
    };

    const initAllIssueStatuses = async () => {
      const defaultIssues =
        issueAllStatuses ?? (await IssueStatusService.getAllStatuses());
      setIssueAllStatuses(defaultIssues);
      setIssueStatuses(defaultIssues);
      setIsIssueStatusesLoaded(true);
    };

    if (
      projectFilter.length === 0 ||
      (projectFilter.length === 1 && projectFilter[0].value === 'ALL_PROJECTS')
    ) {
      initAllIssueStatuses();
    } else {
      initProjectsIssueStatuses();
    }
  }, [projectFilter]);

  return (
    <IssueStatusesContext.Provider
      value={{
        issueStatuses,
        isIssueStatusesLoaded,
      }}
    >
      {children}
    </IssueStatusesContext.Provider>
  );
}
